import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-cube-01',
  imports: [],
  templateUrl: './cube-01.html',
  styleUrl: './cube-01.scss',
})
export class Cube01 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
